export default __webpack_public_path__ + "static/media/agent-india.085dd296.png";